import currency from 'currency.js'

export default function (price: number, insurancePercentage: number = 0.05): number {
  return currency(price).multiply(insurancePercentage).value
}
